import { lazy } from 'react';

const TransformedPageMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/transformed-material',
			component: lazy(() => import('./TransformedPageMaterial'))
		}
	]
};

export default TransformedPageMaterialConfig;
